/* app/js/src/components/common/separate-time-picker/time-slice/time-slice.component.scss */
.container {
  height: 30px;
  width: 55px;
  border-radius: 4px;
  display: flex;
  border: 1px solid #e1e6eb;
}
.container input {
  width: 33px;
  height: 100%;
  border: none;
  outline: none;
  border-right: 1px solid #e1e6eb;
  padding: 5px;
}
.container input::-webkit-inner-spin-button,
.container input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.container .controls {
  width: 23px;
  line-height: 23px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  justify-content: center;
}
.container .controls div {
  cursor: pointer;
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 15px;
  padding-right: 3px;
  width: 21px;
}
.container .controls div ::ng-deep svg {
  width: 11px;
  height: 7px;
}
.container .controls div:hover ::ng-deep svg path {
  fill: #232f3a;
}
.container .controls div.up ::ng-deep svg {
  transform: rotate(180deg);
}
.container .controls div.down {
  border-top: 1px solid #e1e6eb;
}
/*# sourceMappingURL=time-slice.component.css.map */
